import React from 'react';

import { ControlledAccordion } from '@nerdwallet/react-accordion';

import { useControlPanelAccordionToggle } from './hooks/use-control-panel-accordion-toggle';

const FORM_NAME = 'controlPanel';

export type AccordionItem = {
  header: string;
  children: React.ReactNode;
};

type Props = {
  items: AccordionItem[];
  className?: string;
};

const ControlPanelAccordion = ({ items, className }: Props): JSX.Element => {
  const { activeIndex, setActiveIndex } = useControlPanelAccordionToggle({
    formName: FORM_NAME,
    fieldName: 'header',
    items,
  });

  const accordionItems = items.map((item, index) => ({
    title: item.header,
    expanded: activeIndex === index,
    onSelect: () => setActiveIndex(index),
    children: item.children,
  }));

  return <ControlledAccordion items={accordionItems} className={className} />;
};

export default ControlPanelAccordion;
